import Axios from 'axios';

export default {

  // 图片验证码
  codeImg() {
    return Axios.get('/base/api/admin/login-code');
  },

  // 登录
  login(
    username,
    password,
    ckey,
    captcha
  ) {
    return Axios.post('/base/api/admin/login', {
      username,
      password,
      ckey,
      captcha
    });
  },

  // 注销
  logout() {
    return Axios.delete('/base/api/admin/logout');
  },

  // 找回密码 验证码
  forgetPasswordCode(
    mobile
  ) {
    return Axios.post('/base/api/admin/password-retrieve-code', {
      mobile
    });
  },

  // 找回密码 验证验证码
  checkForgetPasswordCode(
    mobile,
    code
  ) {
    return Axios.post('/base/api/admin/verify-password-code', {
      mobile,
      code
    });
  },

  // 找回密码 修改密码
  changePassword(
    mobile,
    code,
    password,
    password_confirmation
  ) {
    return Axios.post('/base/api/admin/reset-password', {
      mobile,
      code,
      password,
      password_confirmation
    });
  },

  // 用户登录信息
  userInfo() {
    return Axios.get('/base/api/admin/users/info');
  },

  // 修改密码
  resetPassword(
    old_password,
    password,
    password_confirmation
  ) {
    return Axios.post('/base/api/admin/users/password-edit', {
      old_password,
      password,
      password_confirmation
    });
  },

  // 菜单
  menuList(
    isPlatformUser
  ) {
    return Axios.get('/base/api/admin/user-menu', {
      params: {
        is_overall: isPlatformUser ? null : 1
      }
    });
  }

}